import {
  buildAssistantTextRevealMetadata,
  type AssistantPresentationModel,
} from "@triedge/ai-assistant-ui";
import assistantResponseRenderPolicy from "../../config/ai-assistant/assistant-response-render-policy.json";

type AssistantPresentationLike = Pick<
  AssistantPresentationModel,
  "module" | "responseKind" | "routeFamily" | "sections"
>;

const normalizeKey = (value: unknown): string =>
  String(value ?? "").trim().toLowerCase();

const hasVisibleStructuredSection = (
  presentation: AssistantPresentationLike,
): boolean =>
  presentation.sections.some((section) => {
    const sectionType = normalizeKey(section.type);
    return (
      sectionType !== "summary" &&
      sectionType !== "formatted_body" &&
      sectionType !== "sources" &&
      sectionType !== "related_links" &&
      sectionType !== "diagnostics"
    );
  });

export const shouldBypassLiveAssistantTextReveal = (
  presentation: AssistantPresentationLike | null | undefined,
): boolean => {
  if (!presentation || !hasVisibleStructuredSection(presentation)) {
    return false;
  }
  const moduleKey = normalizeKey(presentation.module);
  const routeFamilyKey = normalizeKey(presentation.routeFamily);
  return moduleKey === "students-families" || routeFamilyKey === "students-families";
};

export const buildLiveAssistantResponseRenderMetadata = (
  presentation: AssistantPresentationLike | null | undefined,
): { textReveal?: unknown } => {
  if (shouldBypassLiveAssistantTextReveal(presentation)) {
    return {};
  }
  const textReveal = buildAssistantTextRevealMetadata({
    policy: assistantResponseRenderPolicy,
    responseKind: presentation?.responseKind ?? null,
  });
  return textReveal ? { textReveal } : {};
};
